import { IAppState } from '../appState';
import {
  selectHasOwnedRowsWithoutTgvRow,
  selectIsTgvGroupIncomplete,
} from './tiergruppeWarenkorb.selector';
import { selectIsShopPricingStale } from './transient-state.selector';

export enum CheckoutBlockReason {
  STALE_SHOP_PRICING = 'STALE_SHOP_PRICING',
  TGV_GROUP_DELETION_PENDING = 'TGV_GROUP_DELETION_PENDING',
  TGV_GROUP_INCOMPLETE = 'TGV_GROUP_INCOMPLETE',
}

export const selectCheckoutBlockReason = (state: IAppState): CheckoutBlockReason | null => {
  if (selectIsShopPricingStale(state)) {
    return CheckoutBlockReason.STALE_SHOP_PRICING;
  }
  if (selectHasOwnedRowsWithoutTgvRow(state)) {
    return CheckoutBlockReason.TGV_GROUP_DELETION_PENDING;
  }
  if (selectIsTgvGroupIncomplete(state)) {
    return CheckoutBlockReason.TGV_GROUP_INCOMPLETE;
  }
  return null;
};
